'use strict';

/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {string} name  The name of the cookie
 * @return {string | undefined}       The cookie value
 */
function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    var result;

    if (parts.length === 2) {
        result = parts.pop().split(';').shift();
    }
    return result;
}

function getCurrentSiteId() {
    // return window.CQuotient && window.CQuotient.siteId;
    // documentation talks about siteId but in pwa we're using clientId
    return window.CQuotient && window.CQuotient.clientId;
}

function getCurrentInstanceType() {
    return window.CQuotient && window.CQuotient.instanceType;
}

/**
 * Get the cookieId, which is a unique identifier used for linking subsequent activities to the same user.
 * If the cookieId is not defined, then Reports & Dashboards will treat the activity as coming from an anonymous user.
 * @returns {string | undefined} value of the cookieId param for Einstein Activities API
 */
function getCookieId() {
    var siteId = getCurrentSiteId();
    // This usid cookie is set by either PWA or plugin_slas
    return getCookie('usid_' + siteId) || getCookie('usid') || undefined;
}

/**
 * Get the userId, which is for linking registered users across different devices.
 * @returns {string | undefined} value of the userId param for Einstein Activities API
 */
function getUserId() {
    var siteId = window.CQuotient && window.CQuotient.siteId;
    // This enc_user_id is set by PWA
    return window.localStorage.getItem('enc_user_id_' + siteId) || window.localStorage.getItem('enc_user_id') || undefined;
}

/**
 * Fire a given Einstein activity with the provided data.
 *
 * @param {string} name - The name of the activity.
 * @param {Object} data - The activity payload.
 */
function fireEinsteinActivity(name, data) {
    // NOTE: These should be placed in the custom preferences of BM. This will help
    // avoid any code deployments if you need to change these values.
    // NOTE 2: this is _Einstein_ site id (not the same as SFRA one like RefArch).
    var SITE_ID = getCurrentSiteId();
    var CLIENT_ID = '6dcc5f0e-0278-40b7-aecc-3883320e9d43';
    // Reports & Dashboards will only show data that's been tagged as `prd` (production)
    var INSTANCE_TYPE = getCurrentInstanceType();

    // Assign the realm to the data.
    var activityData = Object.assign(data, {
        realm: SITE_ID.split('-')[0],
        instanceType: INSTANCE_TYPE
    });

    var userId = getUserId();
    var cookieId = getCookieId();
    // Apply payload information for logged in users.
    if (userId) {
        activityData = Object.assign(activityData, {
            userId: userId
        });
    }

    if (cookieId) {
        activityData = Object.assign(activityData, {
            cookieId: cookieId
        });
    }

    var url = 'https://api.cquotient.com/v3/activities' +
                '/' + SITE_ID +
                '/' + name;

    try {
        fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                'x-cq-client-id': CLIENT_ID
            },
            method: 'POST',
            body: JSON.stringify(activityData)
        });
    } catch (e) {
        console.error(e);
    }
}

function fireProductActivity() {
    try {
        const masterId = $('.product-detail.cc-pdp').data('skumaster');
        if (masterId && masterId.indexOf('OUTFIT') === -1) {
            const analyticsObj = $('.product-detail.cc-pdp .js-analytics-click-product-info-' + masterId);
            const dataSize = analyticsObj.data('size');
            const variationId = analyticsObj.data('variationid');

            if (dataSize) {
                fireEinsteinActivity('viewProduct', {
                    product: {
                        id: masterId,
                        sku: variationId
                    }
                });
            } else if (variationId === masterId) {
                const color = analyticsObj.data('color');
                fireEinsteinActivity('viewProduct', {
                    product: {
                        id: masterId,
                        altId: variationId + color,
                        altIdType: 'vgroup'
                    }
                });
            } else {
                fireEinsteinActivity('viewProduct', {
                    product: {
                        id: masterId,
                        altId: variationId,
                        altIdType: 'vgroup'
                    }
                });
            }
        }
    } catch (e) {}
}

function fireViewRecoActivity(selector) {
    try {
        const products = $(selector);
        const recommendations = [];
        products.toArray().forEach((p) => {
            const sku = $(p).data('pid');
            if (sku) {
                const masterId = $('.js-analytics-click-product-info-' + sku).data('pid');
                recommendations.push({
                    id: masterId,
                    altId: sku,
                    altIdType: 'vgroup'
                });
                $(p).find('.js-analytics-click-product').on('mousedown', function(e) {
                    fireEinsteinActivity('clickReco', {
                        recommenderName: '__UNDEFINED__', // <- value currently used in SFRA for product page TODO: verificare per cart / TY
                        __recoUUID: '',
                        product: {
                            id: masterId,
                            altId: sku,
                            altIdType: 'vgroup'
                        }
                    });
                });
            }
        });
        if (recommendations) {
            fireEinsteinActivity('viewReco', {
                recommenderName: '__UNDEFINED__', // <- value currently used in SFRA for product page TODO: verificare per cart / TY
                __recoUUID: '',
                products: recommendations
            });
        }
    } catch (e) {}
}

function fireAddToCartActivity(product, customFrom) {
    // TODO: come recuperare i valori corretti?
    // const addToCartType = {
    //     automatic: 'pdp',
    //     sticky_bar_top_macro: 'pdp',
    //     sticky_bar_top_micro: 'pdp',
    //     sticky_bar_bottom: 'pdp'
    //     // TODO: ACCEPTED VALUE ONLY pdp, plp, recs, quick add and wishlist | leggere customFrom + altri valori
    // }
    // let from = customFrom ? addToCartType[customFrom] : null;
    // if (!from && $('.product-detail:not(.product-set-detail)').length) {
    //     from = ''
    // } else if ($('.product-detail').length) {
    //     from 
    // }

    fireEinsteinActivity('addToCart', {
        products: [product],
        source: 'pdp'
    });
}

function fireCartShowActivity () {
    try {
        const cartElements = $('.cc-cart__productItemsContainer .cc-item-wrapper').toArray();
        const products = [];
        let amount = 0;
        cartElements.forEach((el) => {
            const sku = $($(el).find('.js-item-sku')[0]).data('sku');
            const color = $($(el).find('.js-item-color')[0]).data('color');
            const price = $($(el).find('.js-analytics-click-product-info-' + sku)[0]).data('price');
            const quantity = $($(el).find('.js-item-quantity')[0]).data('quantity');
            products.push({
                id: sku.split(color)[0],
                sku: sku,
                price: price,
                quantity: quantity
            });
            amount += (parseFloat(price) * parseInt(quantity));
        });
        fireEinsteinActivity('beginCheckout', {
            products: products,
            amount: amount
        });
    } catch (e) {}
}

function fireCheckoutStepActivity () {
    const checkoutSteps = {
        cart: 1,
        login: 2,
        shippingMethod: 3,
        shipping: 4,
        payment: 5
    };

    try {
        const checkoutStep = $('.data-checkout-stage').attr('data-checkout-stage');
        const basketId = $('.js-checkoutNew').data('checkout-basket');

        fireEinsteinActivity('checkoutStep', {
            stepName: checkoutStep,
            stepNumber: checkoutSteps[checkoutStep],
            basketId: basketId

        });
    } catch (e) {}
}

function initEinsteinTracker() {
    const currentAction = $('.page').data('action');
    switch (currentAction) {
    case 'Home-Show':
    case 'Page-Show':
        fireEinsteinActivity('viewPage', {});
        break;
    case 'Product-Show':
        fireProductActivity();
        break;
    case 'Cart-Show':
        fireCartShowActivity();
        break;
    case 'Checkout-Begin':
        fireCheckoutStepActivity();
        break;
    }
}

var exports = {
    initEinsteinTracker: initEinsteinTracker,
    fireViewRecoActivity: fireViewRecoActivity,
    fireAddToCartActivity: fireAddToCartActivity,
    fireCheckoutStepActivity: fireCheckoutStepActivity
};

module.exports = exports;
